import * as React from 'react';

import { getRegionById } from '../../utils';
import { IRegion } from '../../types/region';
import * as styles from './vacancies_filter.css';
import { SuggestInput } from '../suggest_input';
import { Button, Input, InputGroup, NumberInput, Tooltip } from '@cian/ui-kit';
import { MAX_SALARY } from '../../constants/salary';

export interface ISearchFilter {
  region: number;
  minSalary?: number;
  maxSalary?: number;
  companyName?: string;
  p?: number;
}

interface IVacanciesFilterProps {
  regionsWithVacancy: IRegion[];
  onSearch(search: ISearchFilter): void;
  filter: ISearchFilter;
}

interface IVacanciesFilterState {
  region: IRegion;
  minSalary?: number;
  maxSalary?: number;
  companyName?: string;
  minSalaryIsValid: boolean;
}

const notFoundText = (
  <div>
    <div className={styles['not_found-text-bold']}>Ничего не найдено</div>
    <div className={styles['not_found-text']}>Укажите другой город</div>
  </div>
);

export class VacanciesFilter extends React.Component<IVacanciesFilterProps, IVacanciesFilterState> {
  public constructor(props: IVacanciesFilterProps) {
    super(props);

    this.state = {
      companyName: props.filter.companyName,
      maxSalary: props.filter.maxSalary,
      minSalary: props.filter.minSalary,
      minSalaryIsValid: true,
      region: getRegionById(props.regionsWithVacancy, props.filter.region),
    };
  }

  public render() {
    return (
      <div className={styles['wrapper']}>
        <div className={styles['container']}>
          <div className={styles['region']}>
            <SuggestInput
              width={200}
              region={this.state.region}
              onSelect={value =>
                this.setState({
                  region: getRegionById(this.props.regionsWithVacancy, +value),
                })
              }
              suggestions={this.props.regionsWithVacancy.map(r => ({
                value: r.id,
                label: r.displayName,
              }))}
              valueNotFound={notFoundText}
            />
          </div>
          <div className={styles['salary']}>
            <span>Зарплата</span>
            <div className={styles['salary-range']}>
              {!this.state.minSalaryIsValid && (
                <Tooltip title="Значение «от» не может быть больше значения «до»" placement="bottom-start">
                  <span className={styles['min_salary-tooltip_content']}>&nbsp;</span>
                </Tooltip>
              )}
              <InputGroup>
                <NumberInput
                  min={0}
                  max={MAX_SALARY}
                  onChange={value => this.setState({ minSalary: value, minSalaryIsValid: true })}
                  placeholder="от"
                  value={this.state.minSalary}
                />
                <NumberInput
                  min={0}
                  max={MAX_SALARY}
                  onChange={value => this.setState({ maxSalary: value, minSalaryIsValid: true })}
                  placeholder="до"
                  value={this.state.maxSalary}
                />
              </InputGroup>
            </div>
            <span>₽/мес.</span>
          </div>
          <div className={styles['company_name']}>
            <Input
              value={this.state.companyName || ''}
              placeholder="Название компании"
              onChange={(e, value) => this.setState({ companyName: value })}
            />
          </div>
          <div className={styles['search_btn']}>
            <Button data-name="FilterSearchButton" size="XS" theme="fill_primary" onClick={this.search.bind(this)}>
              Найти
            </Button>
          </div>
        </div>
      </div>
    );
  }

  private search() {
    if (this.state.minSalary && this.state.maxSalary && this.state.minSalary > this.state.maxSalary) {
      this.setState({
        minSalaryIsValid: false,
      });
    } else {
      this.props.onSearch({
        companyName: this.state.companyName,
        maxSalary: this.state.maxSalary,
        minSalary: this.state.minSalary,
        region: this.state.region.id,
      });
    }
  }
}
